export default "__VITE_ASSET__DJEjMHiD__"